export class Response_dml_bean {
    codigoRespuestaServicio:String;
    codigoRegistroBD:String;
    mensaje:String;
}

export class ResponseMensaje {
    codigoRespuesta:String;
    mensaje:String;
}

export class MensajeResponseBeanM {
	codigoservicerespuesta:String;
	codigorespuestabd:String;
	descripcion:String;
}

export class MensajeServicioUtil {
  codigo:String;
  mensaje:String;
}
export class MensajeServicioAD {
  httpStatus:String;
  response:ResponseServicioAD;
}
export class ResponseServicioAD {
  id:String;
  codeResponse:String;
  response:String;
  list:Array<string>;
}
